/**************************************************
 * Nombre:       Dialogo_Producto_Variantes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Producto_Variante from "../../Formularios/Producto/Formulario_Producto_Variante";

const Dialogo_Producto_Variantes = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        entidad.fecha = new Date().getTime()
        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data
        nuevoAviso({aviso: 'Imagen subida'})


        let dox = await guardarDoc('productos', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Producto_Variante props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>



        </Grid>
    )

}
export default Dialogo_Producto_Variantes